module.exports = __webpack_public_path__ + "img/main_banner.200cc754.jpg";